import React from 'react';
import Slider from 'react-slick';
import { Box } from '@hover/blueprint';
import styled from '@emotion/styled';
import { StaticImage } from 'gatsby-plugin-image';
import Slide from './Slide';

const PrevArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M20 24L12 16L20 8"
      stroke="#0E3054"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NextArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M12 24L20 16L12 8"
      stroke="#0E3054"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StyledDiv = styled.div`
  width: 100%;

  .slick-slider {
    width: 1440px;
  }

  .custom-arrow {
    background: white;
    cursor: pointer;
    width: 48px;
    height: 48px;
    position: absolute;
    top: 50%;
    transform: translate(50%);
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  .next-custom-arrow {
    right: 74px;
  }

  .prev-custom-arrow {
    left: 25px;
  }

  @media (max-width: 834px) {
    .slick-slider {
      width: 100%;
    }

    .next-custom-arrow {
      right: 34px;
    }

    .prev-custom-arrow {
      left: -14px;
    }

    .custom-arrow {
      top: 44%;
    }
  }

  @media (max-width: 1400px) {
    .slick-slider {
      width: 100%;
    }
  }
`;

interface CustomArrowProps {
  onClick: () => void;
}

const PrevArrow: React.FC<CustomArrowProps> = ({ onClick }) => (
  <Box onClick={onClick} className="custom-arrow prev-custom-arrow" shadow="md">
    <PrevArrowIcon />
  </Box>
);

const NextArrow: React.FC<CustomArrowProps> = ({ onClick }) => (
  <Box onClick={onClick} className="custom-arrow next-custom-arrow" shadow="md">
    <NextArrowIcon />
  </Box>
);

const Carousel = () => {
  const sliderRef = React.useRef<Slider>(null);

  const handlePrevArrowClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNextArrowClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const sliderConfig = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: <PrevArrow onClick={handlePrevArrowClick} />,
    nextArrow: <NextArrow onClick={handleNextArrowClick} />,
  };

  return (
    <StyledDiv>
      <Box
        w="100%"
        justifyContent="center"
        h={{ base: 'auto', tablet: 'auto', desktop: '374px' }}
      >
        <Slider {...sliderConfig} ref={sliderRef}>
          <Slide
            beforeImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_1_before.png"
              />
            }
            afterImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_1_after.png"
              />
            }
          />
          <Slide
            beforeImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_7_before.png"
              />
            }
            afterImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_7_after.png"
              />
            }
          />
          <Slide
            beforeImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_9_before.png"
              />
            }
            afterImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_9_after.png"
              />
            }
          />
          <Slide
            beforeImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_2_before.png"
              />
            }
            afterImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_2_after.png"
              />
            }
          />
          <Slide
            beforeImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_3_before.png"
              />
            }
            afterImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_3_after.png"
              />
            }
          />
          <Slide
            beforeImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_4_before.png"
              />
            }
            afterImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_4_after.png"
              />
            }
          />
          <Slide
            beforeImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_5_before.png"
              />
            }
            afterImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_5_after.png"
              />
            }
          />
          <Slide
            beforeImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_6_before.png"
              />
            }
            afterImage={
              <StaticImage
                placeholder="blurred"
                alt="marketing"
                src="../../../assets/images/design_orders_slider_6_after.png"
              />
            }
          />
        </Slider>
      </Box>
    </StyledDiv>
  );
};

export default Carousel;
